import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import icontrash from "../../assets/images/product/trash.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import iconEdit from "../../assets/images/product/edit.svg";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import { AiOutlineMore } from "react-icons/ai";
import SearchableSelect from "../../components/selectForm";
import FormDetail from "./form/detail";
import FormInfo from "./form/info";
import { useCategories } from "../../categorys/registerCheckIn/index";
import toast from "react-hot-toast";
import { registerCheckInCall } from "../../api/registerCheckin";
import DeleteDialog from "../../components/dialog/delete";
import { useRegisterCheckIn } from "../../hooks/useRegisterCheckIn";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";

const TableRegisterCheckIn = ({ isRefetchingWithCreate, paramData }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();

  const [search, setSearch] = useState("");
  const [isAddRegisterCheckIn, setIsAddRegisterCheckIn] = useState(false);
  const [employeeId, setEmployeeId] = useState(null);
  const [saleAreaId, setSaleAreaId] = useState(null);
  const [saleBlockId, setSaleBlockId] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [dataDel, setDataDel] = useState(null);
  const [status, setStatus] = useState(null);
  const [zIndex, setZIndex] = useState(1);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });
  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(shouldFetch, saleAreaId);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee]
  );

  const saleAreas = useMemo(
    () => formatEntries(constantData?.saleArea),
    [constantData?.saleArea]
  );

  const saleBlocks = useMemo(
    () => formatEntries(constantData?.saleBlock),
    [constantData?.saleBlock]
  );

  const branchs = useMemo(
    () => formatEntries(constantData?.branch),
    [constantData?.branch]
  );

  const statusDatas = [
    {
      key: "PENDING",
      value: "Chưa duyệt",
    },
    {
      key: "REJECTED",
      value: "Không được phê duyệt",
    },
    {
      key: "APPROVED",
      value: "Đã được duyệt",
    },
  ];

  const {
    registerCheckInData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useRegisterCheckIn(
    debouncedSearchTerm,
    status,
    employeeId,
    saleBlockId,
    saleAreaId,
    branchId,
    startDate,
    endDate
    // apartmentId
  );

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);

  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    paramData({
      search: debouncedSearchTerm,
      status,
      employeeId,
      saleBlockId,
      saleAreaId,
      branchId,
      startDate,
      endDate,
    });
  }, [
    paramData,
    debouncedSearchTerm,
    status,
    employeeId,
    saleBlockId,
    saleAreaId,
    branchId,
    startDate,
    endDate,
  ]);

  // console.log(registerCheckInManagementData)
  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Trạng thái",
        key: "status",
      },
      {
        label: "Mã NV",
        key: "code",
      },
      {
        label: "Tên NV",
        key: "fullName",
      },
      {
        label: "Khối",
        key: "saleBlock",
      },
      {
        label: "Vùng",
        key: "saleArea",
      },
      {
        label: "Chi nhánh",
        key: "branch",
      },
      {
        label: "Địa điểm",
        key: "checkinPlace",
      },
      {
        label: "Số công",
        key: "workingDayRate",
      },
      {
        label: "Lý do",
        key: "comment",
      },
      {
        label: "Thời gian tạo bản ghi chấm công",
        key: "createdAt",
      },
    ],
    data: registerCheckInData,
  };

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  // table
  const handlePopup = (type, e) => {
    if (type) {
      setDataEdit(e?.edit);
    } else {
      setDataEdit(e?.detail);
    }

    setIsAddRegisterCheckIn(type);
    onOpen();
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang sửa bản ghi chấm công ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );

      const { id, ...dataFilter } = filteredData;

      await registerCheckInCall.update(id, dataFilter);

      await refetch();
      onToggle();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const handleOpenDeleteRegisterCheckIn = (data) => {
    setDataDel(data);
  };

  const handleCloseDeleteRegisterCheckIn = () => {
    setDataDel(null);
  };
  const onSubmitDelete = async () => {
    const toastDelete = toast.loading("Đang xóa bản ghi chấm công ...");
    try {
      const { id } = dataDel;
      await registerCheckInCall.delete(id);
      await refetch();
      setDataDel(null);
      toast.success("Xóa thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi xóa");
    }
    toast.dismiss(toastDelete);
  };

  const submitStatus = async (status, id) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    try {
      await registerCheckInCall.approve(id, dataFormat);
      await refetch();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Mã nhân viên, tên nhân viên, lý do,... "
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  backgroundColor={"var(--fill-avatar)"}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <SearchableSelect
                  isShowSearch={true}
                  options={statusDatas}
                  initialSelectedOption={{ key: 0, value: "Trạng thái" }}
                  setValue={setStatus}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={employees}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn nhân viên tạo",
                  }}
                  setValue={setEmployeeId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={saleAreas}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn vùng",
                  }}
                  setValue={setSaleAreaId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={saleBlocks}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn khối",
                  }}
                  setValue={setSaleBlockId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={branchs}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn chi nhánh",
                  }}
                  setValue={setBranchId}
                />
                <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    onFocus={() => {
                      setZIndex(3);
                    }}
                    onBlur={() => {
                      setZIndex(1);
                    }}
                    isClearable={true}
                    placeholderText="Ngày tạo từ ngày - đến ngày"
                    className="datePickerStyle"
                  />
                  {!startDate && !endDate && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "code") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "status") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "fullName") {
                          width = "15%";
                          textAlign = "start";
                        } else if (e.key === "checkinPlace") {
                          width = "20%";
                          textAlign = "start";
                        } else if (
                          e.key === "workingDayRate" ||
                          e.key === "saleBlock" ||
                          e.key === "branch" ||
                          e.key === "saleArea"
                        ) {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "comment") {
                          width = "20%";
                          textAlign = "start";
                        } else if (e.key === "codeProduct") {
                          width = "10%";
                          textAlign = "start";
                        } else if (
                          e.key === "timeDelivery" ||
                          e.key === "timeStart" ||
                          e.key === "timeEnd"
                        ) {
                          width = "5%";
                          textAlign = "end";
                        } else {
                          width = "10%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(false, e)}
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(true, e)}
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenDeleteRegisterCheckIn(e?.edit)
                                    }
                                  >
                                    <Image src={icontrash} /> Xóa bản ghi
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              {rowIndex + 1}
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "status") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "fullName") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "checkinPlace") {
                                width = "20%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "workingDayRate" ||
                                keyvalue === "saleArea" ||
                                keyvalue === "branch" ||
                                keyvalue === "saleBlock"
                              ) {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "comment") {
                                width = "20%";
                                textAlign = "start";
                              } else if (keyvalue === "codeProduct") {
                                width = "10%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "timeDelivery" ||
                                keyvalue === "timeStart" ||
                                keyvalue === "timeEnd"
                              ) {
                                width = "5%";
                              } else {
                                width = "10%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }

                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {keyvalue === "status"
                                      ? formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          submitStatus,
                                          e.id,
                                        )
                                      : formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {isAddRegisterCheckIn ? (
        <FormDetail
          isOpen={isOpen}
          onClose={onClose}
          isEdit={true}
          defaultValues={dataEdit}
          onSubmit={onSubmitEdit}
        />
      ) : (
        <FormInfo
          isOpen={isOpen}
          onClose={onClose}
          defaultValues={dataEdit}
          refetch={refetch}
        />
      )}

      {dataDel && (
        <DeleteDialog
          isOpen={!!dataDel}
          onClose={handleCloseDeleteRegisterCheckIn}
          title={"Xóa registerCheckIn"}
          description={
            <Flex display={"inline"}>
              "Bạn có chắc chắn muốn xóa bản ghi{" "}
              <Text fontWeight={"600"} display={"inline"}>
                {dataDel?.name}
              </Text>{" "}
              này không?"
            </Flex>
          }
          action={() => onSubmitDelete()}
        />
      )}
    </>
  );
};

export default TableRegisterCheckIn;
